/**
 * Shared configuration for the GEMS Live platform.
 *
 * Single-domain architecture:
 *   gemslive.tv      → landing page
 *   gemslive.tv/app  → web app
 *   gemslive.tv/admin→ admin portal
 *   gemslive.tv/api  → backend API
 *
 * The API base URL is the same domain as the frontend.
 * In production it resolves to https://gemslive.tv.
 * In preview/dev it uses REACT_APP_BACKEND_URL.
 */

const hostname = window.location.hostname;
const isProduction = hostname === 'gemslive.tv' || hostname === 'www.gemslive.tv';

export function getApiBaseUrl() {
  if (isProduction) {
    return 'https://gemslive.tv';
  }
  return process.env.REACT_APP_BACKEND_URL;
}

export const API_BASE_URL = getApiBaseUrl();
